import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from "react";
import { observer } from "mobx-react";
import { CookieModel } from "../../../models";
import { Form, Spin, Skeleton } from "antd";
import { request } from "../../../utils";
import { useStores } from "../../../store";
import { useNavigate } from "react-router-dom";
import { useLocationQuery, useRouteCookie } from "../../../hooks";
import { CodeMirror, ConfigContent } from "../..";
import { FormService, useFormServiceHandler, useFormServiceProvider } from "@devowl-wp/react-cookie-banner-admin";
import { FormServiceLayout } from "@devowl-wp/react-cookie-banner-admin";
import { locationRestForwardCookieGet } from "../../../wp-api";
import { slugify, scrollTo, base64EncodeUnicodeSafe } from "@devowl-wp/react-utils";
const CookieEditForm = observer((param)=>{
    let { template, overwriteAttributes, navigateAfterCreation = true, scrollToTop = true, onCreated } = param;
    var _cookie_data_meta, _cookie_data, _templateModel_use;
    const { routeGroup: { group, link }, cookie, id, queried, fetched } = useRouteCookie();
    const navigate = useNavigate();
    const { initiallyScrollToField } = useLocationQuery();
    const { cookieStore, optionStore: { isTcf, isGcm, isGcmShowRecommandationsWithoutConsent, isBannerLessConsent, isDataProcessingInUnsafeCountries, isConsentForwarding, setCookiesViaManager, createdTagManagers, territorialLegalBasis, others: { useEncodedStringForScriptInputs, activePlugins, iso3166OneAlpha2, frontend: { predefinedDataProcessingInSafeCountriesLists } } } } = useStores();
    const { essentialGroup } = cookieStore;
    const templateModel = (cookie == null ? void 0 : cookie.templateModel) || cookieStore.templatesServices.get(template == null ? void 0 : template.identifier);
    const groups = cookieStore.groups.sortedGroups.map((param)=>{
        let { data: { id, name } } = param;
        return {
            id,
            name
        };
    });
    const allowContentBlockerCreation = !!navigateAfterCreation;
    const { prompt, form, isBusy, defaultValues, onFinish, onFinishFailed, onValuesChange, contextValue } = useFormServiceHandler({
        isEdit: fetched,
        territorialLegalBasis,
        entityTemplateVersion: cookie == null ? void 0 : (_cookie_data = cookie.data) == null ? void 0 : (_cookie_data_meta = _cookie_data.meta) == null ? void 0 : _cookie_data_meta.presetVersion,
        attributes: overwriteAttributes,
        selectedGroup: group.key,
        trackFieldsDifferFromDefaultValues: [
            "group"
        ],
        setCookiesViaManager,
        isGcm,
        groups,
        template: templateModel == null ? void 0 : templateModel.use,
        allowContentBlockerCreation,
        shouldUncheckContentBlockerCheckbox: templateModel == null ? void 0 : (_templateModel_use = templateModel.use) == null ? void 0 : _templateModel_use.shouldUncheckContentBlockerCheckbox,
        handleSave: async (values)=>{
            try {
                // Pass as base64-encoded string to avoid Cloudflare XSS issues
                const codeToBase64 = (str)=>useEncodedStringForScriptInputs ? `encodedScript:${base64EncodeUnicodeSafe(str)}` : str;
                const { name, status, providerContact, purpose, isEmbeddingOnlyExternalResources, dataProcessingInCountries, dataProcessingInCountriesSpecialTreatments, technicalDefinitions, group, codeDynamics, createContentBlocker, createContentBlockerId, uniqueName, googleConsentModeConsentTypes, codeOptIn, codeOptOut, codeOnPageLoad, succeessorDeletionCheck, ...meta } = values;
                const newMeta = {
                    ...meta,
                    providerContactPhone: providerContact.phone,
                    providerContactEmail: providerContact.email,
                    providerContactLink: providerContact.link,
                    codeOptIn: codeToBase64(codeOptIn),
                    codeOptOut: codeToBase64(codeOptOut),
                    codeOnPageLoad: codeToBase64(codeOnPageLoad),
                    isEmbeddingOnlyExternalResources,
                    dataProcessingInCountries: JSON.stringify(dataProcessingInCountries),
                    dataProcessingInCountriesSpecialTreatments: JSON.stringify(dataProcessingInCountriesSpecialTreatments),
                    codeDynamics: JSON.stringify(codeDynamics),
                    // Still hold the data of `technicalDefinitions` in database so it is not cleared when activating this option
                    technicalDefinitions: JSON.stringify(isEmbeddingOnlyExternalResources ? initialValues.technicalDefinitions : technicalDefinitions),
                    uniqueName: uniqueName || slugify(name),
                    googleConsentModeConsentTypes: JSON.stringify(googleConsentModeConsentTypes),
                    presetId: templateModel == null ? void 0 : templateModel.data.identifier,
                    presetVersion: templateModel == null ? void 0 : templateModel.data.version
                };
                delete newMeta.templateCheck;
                if (queried) {
                    cookie.setName(name);
                    cookie.setStatus(status);
                    cookie.setPurpose(purpose);
                    cookie.setMeta(newMeta);
                    cookie.setGroup(group);
                    await cookie.patch();
                } else {
                    const useGroup = cookieStore.groups.entries.get(group);
                    const draft = new CookieModel(useGroup.cookies, {
                        title: {
                            raw: name
                        },
                        content: {
                            raw: purpose,
                            protected: false
                        },
                        status,
                        meta: newMeta
                    });
                    await draft.persist();
                    // Delete successor-relevant services
                    if (succeessorDeletionCheck) {
                        const successorOfIds = templateModel.data.consumerData.successorOf.map((param)=>{
                            let { id } = param;
                            return id;
                        });
                        const allCookieModels = cookieStore.groups.sortedGroups.map((param)=>{
                            let { cookies } = param;
                            return [
                                ...cookies.entries.values()
                            ];
                        }).flat();
                        const deleteModels = successorOfIds.map((id)=>allCookieModels.find((param)=>{
                                let { key } = param;
                                return key === id;
                            }) || new CookieModel(cookieStore.essentialGroup.cookies, {
                                id
                            }));
                        await Promise.allSettled(deleteModels.map((m)=>m.delete()));
                    }
                    onCreated == null ? void 0 : onCreated(draft);
                }
                const useCreateContentBlockerId = createContentBlockerId || (templateModel == null ? void 0 : templateModel.data.identifier);
                // Navigate back after creation
                return ()=>navigateAfterCreation && (createContentBlocker ? navigate(`/blocker/new?force=${useCreateContentBlockerId}&comingFromServiceCreation=1${typeof navigateAfterCreation === "string" ? `&navigateAfterCreation=${encodeURIComponent(navigateAfterCreation)}` : ""}`) : typeof navigateAfterCreation === "string" ? window.location.href = navigateAfterCreation : navigate(`${link.slice(1)}/${group}`));
            } catch (e) {
                throw e.responseJSON.message;
            }
        }
    });
    const initialValues = fetched ? {
        name: cookie.data.title.raw,
        status: cookie.data.status,
        group: group.key || undefined,
        purpose: cookie.data.content.raw,
        provider: cookie.data.meta.provider,
        isProviderCurrentWebsite: cookie.data.meta.isProviderCurrentWebsite,
        providerContact: {
            phone: cookie.data.meta.providerContactPhone,
            email: cookie.data.meta.providerContactEmail,
            link: cookie.data.meta.providerContactLink
        },
        providerPrivacyPolicyUrl: cookie.data.meta.providerPrivacyPolicyUrl,
        providerLegalNoticeUrl: cookie.data.meta.providerLegalNoticeUrl,
        uniqueName: cookie.data.meta.uniqueName || cookie.data.slug,
        isEmbeddingOnlyExternalResources: cookie.data.meta.isEmbeddingOnlyExternalResources,
        dataProcessingInCountries: JSON.parse(JSON.stringify(cookie.dataProcessingInCountries)),
        dataProcessingInCountriesSpecialTreatments: JSON.parse(JSON.stringify(cookie.dataProcessingInCountriesSpecialTreatments)),
        legalBasis: cookie.data.meta.legalBasis,
        technicalDefinitions: JSON.parse(JSON.stringify(cookie.technicalDefinitions)),
        codeDynamics: JSON.parse(JSON.stringify(cookie.codeDynamics)),
        tagManagerOptInEventName: cookie.data.meta.tagManagerOptInEventName,
        tagManagerOptOutEventName: cookie.data.meta.tagManagerOptOutEventName,
        googleConsentModeConsentTypes: JSON.parse(JSON.stringify(cookie.googleConsentModeConsentTypes)),
        executePriority: cookie.data.meta.executePriority,
        codeOptIn: cookie.data.meta.codeOptIn,
        executeCodeOptInWhenNoTagManagerConsentIsGiven: cookie.data.meta.executeCodeOptInWhenNoTagManagerConsentIsGiven,
        codeOptOut: cookie.data.meta.codeOptOut,
        executeCodeOptOutWhenNoTagManagerConsentIsGiven: cookie.data.meta.executeCodeOptOutWhenNoTagManagerConsentIsGiven,
        codeOnPageLoad: cookie.data.meta.codeOnPageLoad,
        deleteTechnicalDefinitionsAfterOptOut: cookie.data.meta.deleteTechnicalDefinitionsAfterOptOut,
        createContentBlocker: false,
        createContentBlockerId: undefined,
        templateCheck: undefined,
        succeessorDeletionCheck: undefined
    } : defaultValues;
    // Initially load the cookie if not yet done
    useEffect(()=>{
        if (queried && !fetched) {
            // Fetch the cookie within the correct group collection so it gets removed
            // from the original cookie group when it got moved to another cookie group.
            const groupToFetch = [
                ...cookieStore.groups.entries.values()
            ].filter((param)=>{
                let { cookies } = param;
                return cookies.entries.get(id);
            })[0] || group;
            groupToFetch.cookies.getSingle({
                params: {
                    id,
                    context: "edit"
                }
            });
        }
    }, [
        queried,
        fetched
    ]);
    // Lazy load attributes of template model
    useEffect(()=>{
        if (templateModel && !templateModel.use && !templateModel.busy) {
            templateModel.fetchUse();
        }
    }, [
        templateModel
    ]);
    // Scroll to top when opening the form
    useEffect(()=>{
        if (scrollToTop) {
            scrollTo(0);
        }
    }, []);
    const hasServiceByUniqueName = useCallback(async (slug)=>{
        try {
            return (await request({
                location: locationRestForwardCookieGet,
                params: {
                    slug
                }
            })).filter((d)=>d.ID !== cookie.key).length > 0;
        } catch (e) {
            return false;
        }
    }, [
        cookie.key
    ]);
    const notReady = queried && !fetched || templateModel && !templateModel.use;
    const [FormServiceContextProvider, formServiceContextValue] = useFormServiceProvider({
        ...contextValue,
        isTcf,
        isGcmShowRecommandationsWithoutConsent,
        isBannerLessConsent,
        isDataProcessingInUnsafeCountries,
        isConsentForwarding,
        hasServiceByUniqueName,
        createdTagManagers,
        iso3166OneAlpha2,
        predefinedDataProcessingInSafeCountriesLists,
        essentialGroupId: essentialGroup.key,
        skipIfActiveComponents: activePlugins,
        renderCodeMirror: ()=>/*#__PURE__*/ _jsx(CodeMirror, {
                settings: window.cm_settings
            }),
        initiallyScrollToField
    }, {}, {
        deps: [
            notReady
        ],
        observe: [
            "initiallyScrollToField"
        ]
    });
    if (notReady) {
        return /*#__PURE__*/ _jsx(ConfigContent, {
            maxWidth: "fixed",
            children: /*#__PURE__*/ _jsx(Skeleton, {
                active: true,
                paragraph: {
                    rows: 8
                }
            })
        });
    }
    return /*#__PURE__*/ _jsx(ConfigContent, {
        maxWidth: "fixed",
        children: /*#__PURE__*/ _jsx(FormServiceContextProvider, {
            value: formServiceContextValue,
            children: /*#__PURE__*/ _jsxs(Spin, {
                spinning: isBusy || (templateModel == null ? void 0 : templateModel.busy) || false,
                children: [
                    prompt,
                    /*#__PURE__*/ _jsx(Form, {
                        name: `cookie-${group.key}-${id}`,
                        form: form,
                        ...FormServiceLayout,
                        initialValues: initialValues,
                        onFinish: onFinish,
                        onFinishFailed: onFinishFailed,
                        onValuesChange: onValuesChange,
                        scrollToFirstError: {
                            behavior: "smooth",
                            block: "center"
                        },
                        labelWrap: true,
                        children: /*#__PURE__*/ _jsx(FormService, {})
                    })
                ]
            })
        })
    });
});
export { CookieEditForm };
